<template>
  <div class="content">
    <mu-content-block v-if="!isLoading">

      <mu-breadcrumb style="margin-top: 16px;">
        <mu-breadcrumb-item href="#/faq" @click.native="goToFAQ">FAQs</mu-breadcrumb-item>
        <mu-breadcrumb-item>{{content.question}}</mu-breadcrumb-item>
      </mu-breadcrumb>

      <mu-row gutter>
        <mu-col width="100" desktop="100" tablet="100">
          <mu-card class="top">
            <mu-card-header :title="content.question" titleClass="largeTitle blueTitle"></mu-card-header>
            <video  controlsList="nodownload" controls style="margin-bottom: 16px; width: 100%" v-if="content.video_url !== null"
                   :src="content.video_url"></video>
            <mu-card-text style="padding-top: 0" v-html="content.answer"></mu-card-text>
            <mu-card-actions align="center" style="align-items: center" class="grey">
              <span style="position:relative;top: -6px;font-size: 16px;">{{$t('message.labelRateThisAnswer')}}</span>
              <mu-icon-button
                color="#767676"
                :class="{'active': content.rating === 'UP'}" @click.native="upVote"
                icon="thumb_up">
              </mu-icon-button>
              <mu-icon-button
                color="#767676"
                :class="{'inactive': content.rating === 'DOWN'}"
                @click.native="downVote"
                icon="thumb_down">
              </mu-icon-button>
            </mu-card-actions>
          </mu-card>
        </mu-col>
        <mu-col width="100" desktop="100" tablet="100">

          <!--
          <mu-card class="top">
            <mu-card-header :title="$t('message.labelRelatedQuestions')" titleClass="mediumTitle blackTitle"></mu-card-header>
            <mu-list>
              <div
                v-if="isRecsLoading"
                style="min-height: 200px; display: flex; align-items: center; text-align: center;">
                <mu-circular-progress style="margin: 0 auto"></mu-circular-progress>
              </div>
              <mu-list-item
                v-if="!isRecsLoading"
                v-for="rec, index in recommendations" :key="'rec-' + index"
                :title="rec.question"
                @click.native="goToFaq(rec.faq_id)">
              </mu-list-item>
            </mu-list>

          </mu-card>
          -->
        </mu-col>
      </mu-row>
    </mu-content-block>
    <mu-content-block v-if="isLoading" align="center" style="margin-top: 24px;">
      <mu-circular-progress size="28"></mu-circular-progress>
      <div v-text="$t('message.loadingText')"></div>
    </mu-content-block>
  </div>
</template>

<script>
  import FaqApi from '../../api/Faq'
  import Config from '../../config';
  import MuBreadcrumb from "muse-ui/src/breadCrumb/breadcrumb";

  export default {
    components: {MuBreadcrumb},
    name: "detail",
    watch: {
      '$route': function () {
        let self = this;
        self.isLoading = true;
        self.isRecsLoading = true;
        FaqApi.getById(self.$route.params.id)
          .then(function (response) {
            self.content.question = response.data.question;
            self.content.answer = response.data.answer;
            self.content.category = response.data.name;
            self.content.rating = response.data.rating;
            self.content.video_url = response.data.video_url;
            FaqApi.getRecommendations(self.$route.params.id)
              .then(function (response) {
                self.recommendations = response.data;
                self.isRecsLoading = false;
                self.isLoading = false;
              })
          })
          .catch(function (error) {

          });
      }
    },
    data() {
      return {
        isLoading: true,
        content: {
          question: "",
          answer: ""
        },
        isRecsLoading: true,
        recommendations: []
      }
    },
    mounted() {
      let self = this;

      FaqApi.getById(self.$route.params.id)
        .then(function (response) {
          self.content.question = response.data.question;
          self.content.answer = response.data.answer;
          self.content.category = response.data.name;
          self.content.rating = response.data.rating;
          self.content.video_url = response.data.video_url;

          FaqApi.getRecommendations(self.$route.params.id)
            .then(function (response) {
              self.isRecsLoading = false;
              self.recommendations = response.data;
              self.isLoading = false;
            })

        })
        .catch(function (error) {

        });

    },
    methods: {
      goToFAQ() {
        let self = this;
        self.router.push({
          name: 'Faq'
        })
      },
      upVote(id) {
        let self = this;
        FaqApi.upVote(self.$route.params.id)
          .then(function () {
            self.content.rating = 'UP';
            self.$forceUpdate();
          })
      },
      downVote(id) {
        let self = this;
        FaqApi.downVote(self.$route.params.id)
          .then(function () {
            self.content.rating = 'DOWN';
            self.$forceUpdate();
          })
      },
      goToFaq(id) {
        let self = this;
        self.$router.push({
          name: 'FaqDetail',
          params: {
            id: id
          }
        })
      },
    }
  }
</script>

<style lang="less">


  .mu-breadcrumb-item-separator {
    margin: 0 8px;
    color: #767676;
  }

  .faq-detail {
    margin-bottom: 24px;
    @media (max-width: 600px) {
      padding: 8px;
    }
    .mu-icon-button.active {
      color: #99cb40 !important;
    }
    .mu-icon-button.inactive {
      color: #EA6B4E !important;
    }
    .grey {
      background: #f6f6f6;
    }
    .faq-landing .faq-detail {
      margin: 8px;
    }
    img.smallwidthimgfaq {
      width: 300px;
    }
    img.fullwidthimgfaq {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// Detail.vue?7d28ce72